export default {"src":"/_next/static/media/arrowsout.bdf37a66.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};